import {Button} from "@mui/material";
import {useEffect, useState} from "react";
import I18n from "i18n-js";

interface TryAgainButtonProps {
  onClick: Function;
  disabled: boolean;
}

export default function TryAgainButton({onClick, disabled}: TryAgainButtonProps) {
  const [timeLeft, setTimeLeft] = useState<number>(60);

  useEffect(() => {
    if (timeLeft === 0) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  return (
    <Button
      onClick={() => {
        setTimeLeft(60);
        onClick();
      }}
      disabled={disabled || timeLeft > 0}
      sx={{textDecoration: "none", padding: 0}}
    >
      {I18n.t("Activation.tryAgain") + (timeLeft > 0 ? ` (${timeLeft})` : '')}
    </Button>
  );
}